// extracted by mini-css-extract-plugin
module.exports = {"disclaimers-container":"disclaimers_disclaimers-container___Vv_P","global":"disclaimers_global__qoKta","disclaimers":"disclaimers_disclaimers__fih3m"};